import { plural } from '@cian/utils';
import { connect } from 'react-redux';

import { IAppState } from '../../../../common/state';
import { getDealType } from '../../../../selectors/getDealType';
import { EDealType } from '../../../../types/dealType';
import { getUniqueTotalCountTitle } from '../../../../utils/getUniqueTotalCountTitle';
import { numberToPrettyString } from '../../../../utils/numberToPrettyString';
import { SummaryHeader } from '../../../components/Summary';
import { getOffersCount } from '../utils/selectors';

export function mapStateToProps(state: IAppState) {
  const offersCount = getOffersCount(state);
  const dealType = getDealType(state);
  const isDailyrent = dealType === EDealType.RentDaily;

  /**
   * @todo Прикрутить логику получения данных с бэка в рамках задачи CD-112615
   * @description Данный функционал появился в задаче CD-110067, был удалён в задаче CD-110558
   */
  const totalCountTitle = getUniqueTotalCountTitle(0);

  if (isDailyrent) {
    return { header: '' };
  }

  return {
    header: `Найдено ${numberToPrettyString(offersCount)} ${plural(offersCount, [
      'объявление',
      'объявления',
      'объявлений',
    ])}`.concat(totalCountTitle),
  };
}

export const SummaryHeaderContainer = connect(mapStateToProps)(SummaryHeader);
